import { useQuery } from '@tanstack/react-query';

import { adminAxios } from '@/lib/axios.ts';
import { Application } from '@/types/api.ts';

const fetchApplication = async ({
  applicationId
}: { applicationId: number }): Promise<Application> => {
  const { data } = await adminAxios.get<Application>(`/wizard/applications/${applicationId}`);

  return data;
};

export const useApplication = ({
  applicationId
}: { applicationId: number }) => {
  return useQuery({
    queryKey: ['application', applicationId],
    queryFn: () => fetchApplication({ applicationId }),
    enabled: applicationId > 0
  });
};
